import { Component, Input, Output, EventEmitter } from '@angular/core';
import { NgIf } from '@angular/common';

@Component({
  selector: 'app-img-popup',
  standalone: true,
  imports: [NgIf],
  template: `
    <div class="overlay" *ngIf="imageUrl" (click)="onClose()">
      <div class="popup" (click)="$event.stopPropagation()">
        <button class="close-btn" (click)="onClose()">
          <img src="assets/icons/close-icon.svg" alt="Close" class="close-icon" />
        </button>
        <img [src]="imageUrl" alt="Preview" class="preview-img" />
      </div>
    </div>
  `,
  styles: [`
  /* Overlay covers entire viewport */
.overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.75);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
  backdrop-filter: blur(2px);
  animation: fadeIn 0.2s ease-in-out;
}

/* Popup container */
.popup {
  position: relative;
  background: #fff;
  border-radius: 12px;
  padding: 12px;
  max-width: 90%;
  max-height: 90%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.3);
  animation: zoomIn 0.25s ease-in-out;
}

/* Image */
.preview-img {
  max-width: 100%;
  max-height: 80vh;
  border-radius: 8px;
  object-fit: contain;
  display: block;
}

/* ✅ Close button fixed to top-right corner of screen */
.close-btn {
  position: fixed;
  top: 24px;
  right: 24px;
  background: rgba(0, 0, 0, 0.6);
  border: none;
  border-radius: 50%;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.2s ease;
  z-index: 3000; /* above everything */
}

.close-btn:hover {
  background: rgba(0, 0, 0, 0.8);
}

.close-icon {
  width: 16px;
  height: 16px;
  filter: invert(1);
}


    /* Simple animations */
    @keyframes fadeIn {
      from { opacity: 0; }
      to { opacity: 1; }
    }

    @keyframes zoomIn {
      from { transform: scale(0.9); opacity: 0; }
      to { transform: scale(1); opacity: 1; }
    }
  `]
})
export class ImgPopup {
  @Input() imageUrl: string | null = null;
  @Output() close = new EventEmitter<void>();

  onClose() {
    this.close.emit();
  }
}
